export default {
    title: 'Donate',
    subtitle: 'If you like this project, you consider it hepful or you want to support more similar projects, you can donate.',
    thankyou: 'I really appreciate any kind of help. Thank you',
    oneDollar: {
        title: "1,- USD",
        text:"Projekt podporíš sumou 1,-USD ktorá pomôže udržať web stále dostupný.",
    },
    fiveDollar: {
        title: "5,- USD",
        text:"Sumou 5,- USD pomôžeš zabezpečovať bezchybnosť a aktualizácie.",
    },
    tenDollar: {
        title: "10,- USD",
        text:"Touto sumou umožníš aby sa projekt rýchlejšie zlepšoval a napredoval.",
    },
    moreDollar: {
        title: "Je to na tebe",
        text:" Tu môžeš napísať sumu, ktorá by projektu od teba pomohla najviac.",
    },
}
